import Vue from "vue";

Vue.filter('s3Path', function (value) {
    return process.env.VUE_APP_S3_PATH + value;
});

Vue.filter('date', function (value) {
    value = value.replace(/-/g, "/");
    const date = new Date(value);
    const options = { year: "numeric", month: "long", day: "numeric" };
    return date.toLocaleDateString("en-US", options);
});

Vue.filter('shortDate', function (value) {
    if (!value) {
        return value;
    }
    value = value.replace(/-/g, "/");
    const date = new Date(value);
    const options = { month: "short", day: "numeric" };
    return date.toLocaleDateString("en-US", options);
});

Vue.filter('veryShortBookTitle', function (value) {
    return value.slice(0, 16);
});

Vue.filter('shortBookTitle', function (value) {
    return value.slice(0, 24);
});

Vue.filter('reviews', function (value) {
    if (!value) {
        return "No reviews";
    }
    if (value === 1) {
        return value + " review";
    }
    return value + " reviews";
});

Vue.filter('shortDollars', function (value) {
    if (value % 1 == 0) {
        return value;
    }

    return value.toFixed(2);
});


Vue.filter('readers', function (value) {
    if (!value) {
        return "No readers";
    }
    if (value === 1) {
        return value + " reader";
    }
    return value + " readers";
});

Vue.filter('likes', function (value) {
    if (!value) {
        return "No Likes";
    }
    if (value === 1) {
        return value + " Like";
    }
    return value + " Likes";
});

Vue.filter('retweets', function (value) {
    if (!value) {
        return "No Retweets";
    }
    if (value === 1) {
        return value + " Retweet";
    }
    return value + " Retweets";
});

Vue.filter('followers', function (value) {
    if (!value) {
        return "No people";
    }
    var value = value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    if (value === 1) {
        return value + " person";
    }
    return value + " people";
});

Vue.filter('bigNumber', function (value) {
    return Number(value).toLocaleString();
});